import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useBeraReportV2 } from '@/context/BeraReportV2';

import { Tlid } from './Tlid';
import { NoRisk } from './NoRisk';
import { TaskTime } from './TaskTime';
import { HasKnownInjury } from './HasKnownInjury';
import { CollectionDate } from './CollectionDate';
import { Description, Fields, Title } from './styles';

export function Informations(): JSX.Element {
	const { file } = useBeraReportV2();

	return (
		<div>
			<Title>{I18n.get('Task')}</Title>
			<Description>{I18n.get('Insert below the informations related to the selected video')}</Description>
			<Fields>
				<Row gutter={[40, 32]}>
					<Col xs={24} lg={12}>
						<Tlid />
					</Col>
					<Col xs={24} lg={12}>
						<TaskTime fileId={file.id} />
					</Col>
					<Col xs={24}>
						<NoRisk fileId={file.id} />
					</Col>
					<Col xs={24} lg={12}>
						<CollectionDate fileId={file.id} />
					</Col>
					<Col xs={24} lg={12}>
						<HasKnownInjury fileId={file.id} />
					</Col>
				</Row>
			</Fields>
		</div>
	);
}
